import { IMAGES } from "./images";

// Portfolio / réalisations. Content placeholder — remplacer par vos vraies photos & chantiers.
export const REALISATIONS = [
  {
    slug: "enseigne-lumineuse-restaurant-geneve",
    title: "Enseigne lumineuse pour un restaurant à Genève",
    type: "Enseigne lumineuse • Lettres boîtiers",
    city: "Genève",
    zoneKey: "geneve",
    cover: IMAGES.storefrontNight,
    gallery: [IMAGES.storefrontNight, IMAGES.neonWorkshop, IMAGES.facade],
    alt: "Enseigne lumineuse en lettres boîtiers LED installée sur la façade d'un restaurant à Genève",
    problem: "Un restaurant genevois souhaitait une enseigne chaleureuse, visible le soir, tout en respectant le cachet de l'immeuble du centre-ville.",
    solution: "Lettres boîtiers rétroéclairées en blanc chaud, posées sur bandeau, complétées d'une enseigne drapeau double face pour capter le flux piéton.",
    materials: ["Aluminium laqué noir", "Plexiglas opale", "Modules LED blanc chaud"],
    dimensions: "Bandeau 4,2 m • lettres hauteur 35 cm",
    lighting: "Rétroéclairage halo + face lumineuse, 3000 K",
    fabrication: "Découpe et pliage aluminium, montage LED et test en atelier.",
    installation: "Pose sur nacelle, raccordement et mise en lumière de nuit.",
    result: "Une devanture identifiable de loin, qui a renforcé l'affluence en soirée.",
    services: ["enseigne-lumineuse", "lettres-boitiers", "enseigne-drapeau"],
    locale: "enseigne-lumineuse-geneve",
  },
  {
    slug: "lettres-lumineuses-pharmacie-vaud",
    title: "Croix et lettres lumineuses pour une pharmacie dans le canton de Vaud",
    type: "Enseigne lumineuse • Pharmacie",
    city: "Lausanne",
    zoneKey: "vaud",
    cover: IMAGES.commercial,
    gallery: [IMAGES.commercial, IMAGES.storefront2],
    alt: "Lettres lumineuses LED et croix de pharmacie installées sur une façade dans le canton de Vaud",
    problem: "Une pharmacie vaudoise avait besoin d'une signalétique claire, visible de jour comme de nuit et conforme aux usages.",
    solution: "Lettres boîtiers lumineuses pour le nom et caisson pour le logo, avec un éclairage LED homogène et sobre.",
    materials: ["Aluminium", "Plexiglas vert / blanc", "LED"],
    dimensions: "Enseigne de façade 3,5 m",
    lighting: "Face lumineuse LED, 4000 K",
    fabrication: "Fabrication des lettres et du caisson en atelier.",
    installation: "Pose en façade et raccordement électrique.",
    result: "Une pharmacie immédiatement identifiable dans son quartier.",
    services: ["lettres-lumineuses", "caisson-lumineux", "enseigne-lumineuse"],
    locale: "enseigne-lumineuse-lausanne",
  },
  {
    slug: "enseigne-lumineuse-commerce-annecy",
    title: "Enseigne lumineuse pour un commerce à Annecy",
    type: "Enseigne lumineuse • Commerce",
    city: "Annecy",
    zoneKey: "haute-savoie",
    cover: IMAGES.facade,
    gallery: [IMAGES.facade, IMAGES.storefrontNight],
    alt: "Enseigne lumineuse en lettres relief installée sur la devanture d'un commerce à Annecy",
    problem: "Un commerce du centre d'Annecy voulait une enseigne élégante, compatible avec les prescriptions du secteur sauvegardé.",
    solution: "Lettres relief avec rétroéclairage halo discret, pour un rendu premium respectueux du patrimoine.",
    materials: ["Inox brossé", "LED halo"],
    dimensions: "Enseigne 2,8 m",
    lighting: "Rétroéclairage halo, 3000 K",
    fabrication: "Découpe des lettres inox et intégration LED.",
    installation: "Pose entretoisée et raccordement discret.",
    result: "Une enseigne qualitative, en harmonie avec la vieille ville.",
    services: ["lettres-relief", "enseigne-lumineuse"],
    locale: "enseigne-lumineuse-annecy",
  },
  {
    slug: "totem-concession-pays-de-gex",
    title: "Totem publicitaire pour une concession dans le Pays de Gex",
    type: "Totem • Signalétique extérieure",
    city: "Saint-Genis-Pouilly",
    zoneKey: "pays-de-gex",
    cover: IMAGES.storefront2,
    gallery: [IMAGES.storefront2, IMAGES.workshopWelding],
    alt: "Totem publicitaire lumineux installé devant une concession automobile dans le Pays de Gex",
    problem: "Une concession avait besoin d'un repère visible depuis la route et d'une signalétique de site cohérente.",
    solution: "Totem lumineux double face et signalétique directionnelle assortie.",
    materials: ["Acier galvanisé", "Aluminium", "Plexiglas", "LED"],
    dimensions: "Totem 5 m de hauteur",
    lighting: "Caisson lumineux double face",
    fabrication: "Structure acier, habillage aluminium et faces imprimées.",
    installation: "Massif béton, levage et raccordement.",
    result: "Une visibilité routière forte et une image de marque affirmée.",
    services: ["totem-publicitaire", "signaletique-exterieure", "caisson-lumineux"],
    locale: "enseigne-lumineuse-saint-genis-pouilly",
  },
  {
    slug: "habillage-facade-entreprise-lyon",
    title: "Habillage de façade pour une entreprise à Lyon",
    type: "Habillage façade • Grand format",
    city: "Lyon",
    zoneKey: "lyon",
    cover: IMAGES.workshopWelding,
    gallery: [IMAGES.workshopWelding, IMAGES.craftsmanCutting],
    alt: "Habillage de façade en panneaux composites avec logo d'entreprise à Lyon",
    problem: "Une entreprise lyonnaise voulait moderniser son bâtiment et afficher clairement sa marque.",
    solution: "Habillage de façade en panneaux composites laqués avec logo en lettres relief rétroéclairées.",
    materials: ["Panneaux composites", "Ossature aluminium", "Lettres relief LED"],
    dimensions: "Façade 12 m",
    lighting: "Logo rétroéclairé",
    fabrication: "Découpe des panneaux et préparation de l'ossature.",
    installation: "Pose sur échafaudage et intégration du logo lumineux.",
    result: "Un bâtiment transformé et une identité visible depuis la rue.",
    services: ["habillage-facade", "lettres-relief", "impression-grand-format"],
    locale: "enseigne-lumineuse-lyon",
  },
  {
    slug: "marquage-vehicule-flotte-ain",
    title: "Marquage de flotte d'utilitaires dans l'Ain",
    type: "Marquage véhicule • Covering",
    city: "Saint-Jean-de-Gonville",
    zoneKey: "ain",
    cover: IMAGES.craftsmanCutting,
    gallery: [IMAGES.craftsmanCutting, IMAGES.commercial],
    alt: "Marquage adhésif de véhicules utilitaires aux couleurs d'une entreprise dans l'Ain",
    problem: "Une PME de l'Ain souhaitait transformer ses véhicules en supports publicitaires homogènes.",
    solution: "Marquage partiel harmonisé sur toute la flotte, avec coordonnées et logo lisibles.",
    materials: ["Films coulés qualité auto", "Vinyle de découpe"],
    dimensions: "6 véhicules",
    lighting: "—",
    fabrication: "Conception des gabarits et impression des visuels.",
    installation: "Pose en atelier sur carrosserie préparée.",
    result: "Une flotte qui fait la publicité de l'entreprise à chaque déplacement.",
    services: ["marquage-vehicule", "communication-visuelle"],
    locale: "communication-visuelle-ain",
  },
];

export const REALISATIONS_BY_SLUG = Object.fromEntries(REALISATIONS.map((r) => [r.slug, r]));
export const getRealisation = (slug) => REALISATIONS_BY_SLUG[slug];
